// extracted by mini-css-extract-plugin
export var header = "layout-module--header--aoaNz";
export var main = "layout-module--main--ay8oo";
export var nav = "layout-module--nav--2tH8Y";
export var root = "layout-module--root--4oilu";
export var sidebar = "layout-module--sidebar--em38h";
export var sidebarInner = "layout-module--sidebarInner--5aTEP";
export var sidebarScroll = "layout-module--sidebarScroll--upOET";